import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader, Loading } from "../components/Layout";
import { api, errMsg } from "../lib/api";

export default function GuideIndex() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/seo/guides").then((r) => setD(r.data)).catch(() => setD({ guides: [] })); }, []);
  return (
    <div data-testid="guide-page">
      <PageHeader eyebrow="Guide" title="Guide til dyrlægepriser">Faktuelle forklaringer på, hvordan dyrlægepriser hænger sammen, og hvordan du sammenligner dem. VetPris giver ikke medicinsk rådgivning.</PageHeader>
      {!d ? <Loading /> : (
        <ul className="container-vp py-10 grid gap-4 md:grid-cols-2">
          {d.guides.map((g) => (
            <li key={g.slug}><Link to={`/guide/${g.slug}`} className="group card-vp p-5 block hover:shadow-md" data-testid={`guide-link-${g.slug}`}>
              <h2 className="font-heading text-lg font-bold text-[#153C3A]">{g.title}</h2>
              <p className="text-sm text-[#52706D] mt-1">{g.description}</p>
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#087F72] mt-3">Læs guiden <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
            </Link></li>))}
        </ul>)}
    </div>
  );
}

export const GuideDetail = () => {
  const { slug } = useParams();
  const [g, setG] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { setG(null); api.get(`/seo/guides/${slug}`).then((r) => setG(r.data)).catch((e) => setError(errMsg(e))); }, [slug]);
  if (error) return <div className="container-vp py-16 text-[#52706D]" data-testid="guide-error">{error}</div>;
  if (!g) return <Loading />;
  return (
    <article className="container-vp py-10 max-w-3xl" data-testid="guide-detail">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-[#153C3A]">{g.title}</h1>
      <p className="text-base md:text-lg text-[#52706D] mt-3">{g.description}</p>
      {g.sections.map(([h, t]) => <section key={h} className="mt-8"><h2 className="text-xl font-bold text-[#153C3A]">{h}</h2><p className="text-[#334155] mt-2 leading-relaxed">{t}</p></section>)}
      <p className="text-xs text-[#52706D] mt-8" data-testid="guide-updated">Senest opdateret: {new Date(g.updated).toLocaleDateString("da-DK")}</p>
      <div className="mt-8 flex flex-wrap gap-3"><Link to="/sammenlign" className="btn-primary">Sammenlign priser</Link><Link to="/dyreklinikker" className="btn-outline">Find dyreklinik</Link></div>
      <h2 className="font-bold text-[#153C3A] mt-10">Læs også</h2>
      <ul className="mt-2 space-y-1 text-sm">{g.related.map((r) => <li key={r.slug}><Link to={`/guide/${r.slug}`} className="text-[#087F72] hover:underline">{r.title}</Link></li>)}</ul>
    </article>
  );
};
